/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type CreateXrayTestDtoFinding = (typeof CreateXrayTestDtoFinding)[keyof typeof CreateXrayTestDtoFinding] | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateXrayTestDtoFinding = {
  NORMAL: 'NORMAL',
  ABNORMAL_TB_SUSPICION: 'ABNORMAL_TB_SUSPICION',
  ABNORMAL_TB_UNLIKELY: 'ABNORMAL_TB_UNLIKELY',
} as const;
